<!-- 箱子道具组件UI -->
<template>
  <div class="wrapper">
    <div class="award-image">
      <img class="award-img" :src="img" alt="" />
    </div>
    <!-- <img class="ob" src="@/assets/images/openbox/bg.png" alt=""> -->
    <div class="txt">
      <!-- <div class="a-info a-name fz14 fw4" >{{ delST(info[0]) }}</div> -->
      <div class="a-info a-name fz14 fw4" v-if="name.includes('StatTrak™') && !retainST">
        <span class="stClor" v-if="showST">{{ delST(info[0])[0] }}</span>
        {{ delST(info[0])[1] }}
      </div>
      <div v-else class="a-info a-name fz14 fw4">
        {{ retainST?info[0]:delST(info[0]) }}
      </div>
      <div class="a-info a-color fwb fz16">
        {{ info[1] }}
        <img
          v-if="status == 9"
          class="shareicon"
          src="@/assets/images/battle/shareicon.png"
          alt=""
        />
      </div>
      <div class="a-info a-abrad fz14 fw4">{{ duraAlias }}</div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";

// 道具 三行字段  道具名  颜色描述   磨损度描述
// const props = defineProps(["img", "name", "color", "abrad"]); //道具图片  道具名 道具颜色 道具磨损度
const props = defineProps({
  img: {
    type: String,
  },
  name: {
    type: String,
  },
  color: {
    type: String,
  },
  abrad: {
    type: String,
  },
  showST: {
    type: Boolean,
    default: true,
  },
  retainST: {
    type: Boolean,
    default: false,
  },
  status: {
    type: [String, Number], //饰品回收状态,为数字类型
    default: "normal",
  },
});

//删除StatTrak™
const delST = computed(() => {
  return (val) => {
    if (val.includes("StatTrak™")) {
      // return val.replace('StatTrak™','')
      //道具名包含StatTrak™ 则返回ST缩写
      return ["ST", val.replace("StatTrak™", "")];
    }
    return val;
  };
});

const info = computed(() => {
  // console.log('props:',props.name);
  return props.name.split("|");
});
//  console.log('info:',info.value);
const duraAlias = computed(() => {
  // console.log('abrad;',props.abrad);
  return props.abrad
    ? props.abrad == "无"
      ? ""
      : props.abrad == "Null"
      ? "Vanilla"
      : props.abrad
    : "";
});
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
